import breakpoint from "./breakpoint";

const setDecorations = (menu) => {
  const links = menu.querySelectorAll(".menu-links > li > a");
  const decorations = document.querySelectorAll(".menu-decoration");

  for (const [index, link] of links.entries()) {
    const { top, left, width, height } = link.getBoundingClientRect();
    const { left: menuLeft } = menu.getBoundingClientRect();
    decorations[index].style.left = `${left - menuLeft}px`;

    if (link.classList.contains("is-active")) {
      decorations[index].style.width = `${width}px`;
    } else {
      link.addEventListener("mouseenter", () => {
        decorations[index].style.width = `${width}px`;
      });

      link.addEventListener("mouseleave", () => {
        decorations[index].style.width = "0";
      });
    }
  }
};

const menu = () => {
  const menu = document.querySelector(".menu-links");
  const items = menu.querySelectorAll(".has-children");
  const submenus = menu.querySelectorAll(".menu-sublinks");
  const backLinks = menu.querySelectorAll(".menu-sublinks-back");
  const dropdown = document.querySelector(".header-dropdown-links");
  const overlay = document.querySelector(".header-dropdown-overlay");
  let isOpen = false;

  setDecorations(menu);
  window.addEventListener("resize", () => {
    setDecorations(menu);
  });

  for (const item of items) {
    const submenu = item.querySelector(".menu-sublinks");
    const link = item.querySelector("a");

    link.addEventListener("click", (event) => {
      if (!isOpen) {
        event.preventDefault();
      }

      // mobile
      for (const submenu of submenus) {
        submenu.classList.remove("is-open");
      }
      submenu.classList.add("is-open");
      menu.classList.add("is-open");

      // desktop
      const submenuClone = submenu.cloneNode(true);
      submenuClone.style.display = "block";
      dropdown.innerHTML = "";
      dropdown.appendChild(submenuClone);
      document.body.classList.add("dropdown-open");
      isOpen = true;
    });
  }

  for (const backLink of backLinks) {
    backLink.addEventListener("click", (event) => {
      event.preventDefault();

      for (const submenu of submenus) {
        submenu.classList.remove("is-open");
      }

      menu.classList.remove("is-open");
      document.body.classList.remove("dropdown-open");
      isOpen = false;
    });
  }

  overlay.addEventListener("click", () => {
    document.body.classList.remove("dropdown-open");
    dropdown.innerHTML = "";
  });

  const reset = () => {
    for (const submenu of submenus) {
      submenu.classList.remove("is-open");
    }

    menu.classList.remove("is-open");
    document.body.classList.remove("dropdown-open");
    dropdown.innerHTML = "";
    isOpen = false;
  };

  breakpoint(() => {
    reset();
  });
};

export default menu;
